const PUSH_WORKER_URL = '/push-sw.js';
const PUSH_WORKER_SCOPE = '/push/';
const ACTIVATION_TIMEOUT_MS = 30_000;

let registrationPromise: Promise<ServiceWorkerRegistration> | null = null;

function waitForActivation(registration: ServiceWorkerRegistration) {
  if (registration.active) return Promise.resolve(registration);

  return new Promise<ServiceWorkerRegistration>((resolve, reject) => {
    let worker: ServiceWorker | null = null;
    const timeout = window.setTimeout(() => {
      cleanup();
      reject(new Error('Push service worker activation timed out'));
    }, ACTIVATION_TIMEOUT_MS);

    const checkActivation = () => {
      if (!registration.active) return;
      cleanup();
      resolve(registration);
    };
    const watchInstallingWorker = () => {
      worker?.removeEventListener('statechange', checkActivation);
      worker = registration.installing;
      worker?.addEventListener('statechange', checkActivation);
      checkActivation();
    };
    const cleanup = () => {
      window.clearTimeout(timeout);
      registration.removeEventListener('updatefound', watchInstallingWorker);
      worker?.removeEventListener('statechange', checkActivation);
    };

    registration.addEventListener('updatefound', watchInstallingWorker);
    watchInstallingWorker();
  });
}

export function registerPushServiceWorker() {
  if (registrationPromise) return registrationPromise;

  registrationPromise = navigator.serviceWorker
    .register(PUSH_WORKER_URL, { scope: PUSH_WORKER_SCOPE })
    .then(waitForActivation)
    .finally(() => {
      registrationPromise = null;
    });
  return registrationPromise;
}

export async function unregisterPushServiceWorker() {
  if (!('serviceWorker' in navigator)) return;

  await registrationPromise?.catch(() => undefined);
  const registration = await navigator.serviceWorker.getRegistration(
    PUSH_WORKER_SCOPE
  );
  const scriptUrl =
    registration?.active?.scriptURL ||
    registration?.waiting?.scriptURL ||
    registration?.installing?.scriptURL;
  if (!registration || !scriptUrl) return;

  const url = new URL(scriptUrl);
  if (
    url.origin === window.location.origin &&
    url.pathname === PUSH_WORKER_URL
  ) {
    await registration.unregister();
  }
}
